import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getStudentDetails } from "../../actions/Student.action";
import AddStudentForm from "../../components/AddStudentForm/AddStudentForm";
import Layout from "../../components/shared/Layout/Layout";

const AddStudentPage = ({ edit, student, getStudentDetails }) => {
  const { id } = useParams();
  const studentId = id ? parseInt(id) : null;
  const isSelectedStudent = edit && student && student.id === studentId;

  useEffect(() => {
    if (edit && id && (!student || student.id !== studentId)) {
      getStudentDetails(id);
    }
  }, [edit, id, student, studentId, getStudentDetails]);

  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Student`}>
        {edit && id && isSelectedStudent ? (
          <AddStudentForm edit={true} data={student} />
        ) : edit && id ? (
          <div className="py-5 text-center">Loading student...</div>
        ) : (
          <AddStudentForm />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  student: state.student.selected_student,
});

export default connect(mapStateToProps, { getStudentDetails })(AddStudentPage);
